export default "__VITE_ASSET__jZUBW5kP__"